
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 .431h15v15H0z"}}),_c('path',{attrs:{"fill":"#6D7587","fill-rule":"nonzero","d":"M12.356 6.633l-7.902 7.9L0 15.431l.899-4.455 7.9-7.9 3.557 3.557zm.883-.884L15 3.987 11.443.431l-1.76 1.76 3.556 3.558z"}})])])
          )
        }
      }
    